import { Command } from '@/app/common/base/command'

export class AcceptCardifPremiumCommand extends Command {

    public async run(actionId: string) {
        await this.client.post(`/api/products/cardifao/actions/${actionId}/accept`)
    }

}
